
// src/actions/activity-report.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const FETCH_ACTIVITY_REPORTS = "FETCH_ACTIVITY_REPORTS"
export const FETCH_ACTIVITY_REPORTS_REQUESTED = "FETCH_ACTIVITY_REPORTS_REQUESTED"
export const FETCH_ACTIVITY_REPORTS_COMPLETED = "FETCH_ACTIVITY_REPORTS_COMPLETED"
export const FETCH_ACTIVITY_REPORTS_FAILED = "FETCH_ACTIVITY_REPORTS_FAILED"
export const FETCH_MONTHLY_ACTIVITY_REPORT = "FETCH_MONTHLY_ACTIVITY_REPORT"
export const FETCH_MONTHLY_ACTIVITY_REPORT_REQUESTED = "FETCH_MONTHLY_ACTIVITY_REPORT_REQUESTED"
export const FETCH_MONTHLY_ACTIVITY_REPORT_COMPLETED = "FETCH_MONTHLY_ACTIVITY_REPORT_COMPLETED"
export const FETCH_MONTHLY_ACTIVITY_REPORT_FAILED = "FETCH_MONTHLY_ACTIVITY_REPORT_FAILED"

export function fetchActivityReportsRequested() {
  return {
    type: FETCH_ACTIVITY_REPORTS_REQUESTED
  }
}

export function fetchActivityReports(group_id, date, length = 7) {
  return function(dispatch) {
    dispatch(fetchActivityReportsRequested())
    return api.get(`/activity_report/${group_id}`, { date, length })
        .then((results)=> {
          dispatch(fetchActivityReportsCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchActivityReportsFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchActivityReportsCompleted(results) {
  return {
    type: FETCH_ACTIVITY_REPORTS_COMPLETED,
    results,
  }
}

export function fetchActivityReportsFailed(error) {
  return {
    type: FETCH_ACTIVITY_REPORTS_FAILED,
    error,
  }
}

export function fetchMonthlyActivityReportRequested() {
  return {
    type: FETCH_MONTHLY_ACTIVITY_REPORT_REQUESTED
  }
}

export function fetchMonthlyActivityReport(group_id, user_id, date) {
  return function(dispatch) {
    dispatch(fetchMonthlyActivityReportRequested())
    return api.get(`/activity_report/${group_id}`, { user_id, date })
        .then((results)=> {
          dispatch(fetchMonthlyActivityReportCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchMonthlyActivityReportFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchMonthlyActivityReportCompleted(results) {
  return {
    type: FETCH_MONTHLY_ACTIVITY_REPORT_COMPLETED,
    results,
  }
}

export function fetchMonthlyActivityReportFailed(error) {
  return {
    type: FETCH_MONTHLY_ACTIVITY_REPORT_FAILED,
    error,
  }
}

export const CLEAR_ACTIVITY_REPORTS = "CLEAR_ACTIVITY_REPORTS"
export const CLEAR_MONTHLY_ACTIVITY_REPORTS = "CLEAR_MONTHLY_ACTIVITY_REPORTS"

export function clearActivityReports() {
  return {
    type: CLEAR_ACTIVITY_REPORTS
  }
}

export function clearMonthlyActivityReport() {
  return {
    type: CLEAR_MONTHLY_ACTIVITY_REPORTS
  }
}

export function saveSelectSubmissionScheduleRequested() {
  return {
    type: SAVE_SELECT_SUBMISSION_SCHEDULE_REQUESTED
  }
}


// WEBPACK FOOTER //
// ./src/actions/activity-report.js